__webpack_require__.p = "/lof-truthtable/";